import script from "./SelectDate.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectDate.vue?vue&type=script&setup=true&lang=js"

import "./SelectDate.vue?vue&type=style&index=0&id=37c44227&scoped=true&lang=css"

import exportComponent from "/Users/zane/Dev/ionic-spirit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c44227"]])

export default __exports__